import { render, staticRenderFns } from "./ProformToInvoiceView.vue?vue&type=template&id=e89c8da4&scoped=true&"
import script from "./ProformToInvoiceView.vue?vue&type=script&lang=ts&"
export * from "./ProformToInvoiceView.vue?vue&type=script&lang=ts&"
import style0 from "./ProformToInvoiceView.vue?vue&type=style&index=0&id=e89c8da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89c8da4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
